// Home 
export const home = {
  tagLine: "Hi I am Maniprasad Kadlaskar",
  keywords: ["Engineer" , "Programmer" , "Developer" , "Learner"],
  resume: "https://drive.google.com/file/d/1sqNWCZ6gcrAWH_Ls1PXOpY9LFECClUYz/view?usp=sharing"
}

// About
export const about = {
    description: `I am Maniprasad Kadlaskar Computer Science undergrad at KLS Gogte Institute Of Technology.
    I am enthusiastic learner , programmer , developer and problem solver. I am proficient in web full stack web development (MERN).
    I am fascinated to explore and work in the field of Machine Learning.`,

    image: {
        name: "Maniprasad",
        path: "assets/profile/maniprasad.jpg"
    }
}

// Menu items
export const menuItems = [
    {
        name: "Home",
        path: "home"
    },
    {
        name: "About",
        path: "about"
    },
    {
        name: "Projects",
        path: "project"
    },
    {
        name: "Skills",
        path: "skills"
    },
    {
        name: "Contact",
        path: "contact"
    },
]

// User projects 
export const projects = [
    {
        name: "Blood Donation",
        description: "Website for blood donation registration. This website is developed using MERN stack technology. Node js , Express js and Mongodb is used for backend.And React js , Tailwind CSS for frontend",
        github: "https://github.com/maniprasadkadlaskar/Blood-Donation",
        website: "https://blood-donation-client.vercel.app/",
        image: "assets/projects/blood-donation.png"
    },
    {
        name: "Expense Tracker",
        description: "Expense Tracker is human expenses tracking web application. This application helps user to track his day today expenses. This application is buit using React js as frontend and google firebase as service provider.",
        github: "https://github.com/maniprasadkadlaskar/Expense-Tracker",
        website: "https://expense-tracker-674ad.web.app/",
        image: "assets/projects/expense-tracker.png"
    },
    {
        name: "Clime Weather",
        description: "Clime weather is a weather web application. This web page is built using HTML , CSS and Javascript. It uses Openweathermap API to fetch the data.",
        github: "https://github.com/maniprasadkadlaskar/Clime-Weather",
        website: "https://clime-weather.netlify.app/",
        image: "assets/projects/clime-weather.png"
    }
]

// Skills
export const skills = [
    {
      name: "C",
      path: "assets/skills/c.png"
    },
    {
      name: "C++",
      path: "assets/skills/c++.png"
    },
    {
      name: "Java",
      path: "assets/skills/java.png"
    },
    {
      name: "HTML",
      path: "assets/skills/html.png"
    },
    {
      name: "CSS",
      path: "assets/skills/css.png"
    },
    {
      name: "Javascript",
      path: "assets/skills/javascript.png"
    },
    {
      name: "Python",
      path: "assets/skills/python.png"
    },
    {
      name: "React",
      path: "assets/skills/react.png"
    },
    {
      name: "Node js",
      path: "assets/skills/node-js.png"
    },
    {
      name: "Express js",
      path: "assets/skills/express.png"
    },
    {
      name: "Mongodb",
      path: "assets/skills/mongodb.png"
    },
    {
      name: "My SQL",
      path: "assets/skills/mysql.png"
    },
    {
      name: "Tailwind CSS",
      path: "assets/skills/tailwind-css.png"
    },
    {
      name: "Git",
      path: "assets/skills/git.png"
    },
    {
      name: "Github",
      path: "assets/skills/github.png"
    },
    {
      name: "Canva",
      path: "assets/skills/canva.png"
    },
  ]